export const routes = {
    editStore: '/api/stores/edit',
    deleteStore: '/api/stores/delete',
    getStores: '/api/stores',
    findStore: '/api/stores/find/',
    getUsersAndStores: '/api/admin/get_users_and_stores',
    getStoreRequests: '/api/admin/storeRequests',
    changeStoreStatus: '/api/admin/changeStoreStatus',

}